import { Navigate } from 'react-router-dom';
import { pathsMatch } from '../helpers/general';
import { PublicRouting } from '../models/global';
import { PRIVATE_PATHS } from './data';

const PublicRoute = ({ isLoggedIn, children }: PublicRouting) => {
  const isPrivatePath = PRIVATE_PATHS.find(({ path }) => pathsMatch(`/${path}`, window.location.pathname));
  const isResetPasswordPath = pathsMatch('/reset-password/:resetCode', window.location.pathname);
  if (isLoggedIn && !isResetPasswordPath) {
    return <Navigate to={isPrivatePath ? window.location.pathname : '/'} />;
  }
  return children;
};
export default PublicRoute;
